import React from 'react';

export enum TransferOperationEnum {
  Sending = 'Sending',
  Receiving = 'Receiving',
}

interface TransferCurrencyInfoProps {
  amount: string;
  currency: string;
  operation: TransferOperationEnum;
}

const TransferCurrencyInfo = ({
  amount,
  currency,
  operation,
}: TransferCurrencyInfoProps) => {
  return (
    <div className="p-3 text-center text-white">
      <div className="text-smallRegular">{operation}</div>
      <div className="text-heading4 pt-1.5">
        {amount} {currency}
      </div>
    </div>
  );
};

export default TransferCurrencyInfo;
